import axios from 'axios';
import { DATE_RANGE } from '@/lib/const';
import { getISODate } from '@/lib/utils';

const origin = `${process.env.VUE_APP_ORIGIN}`;
const prefix = 'api';
const originPath = `${origin}/${prefix}/admins/supports`;
const routes = {
  get: {
    supports: originPath,
    supportsData: `${originPath}-data`,
    clientVotes: `${originPath}/client-votes`,
  },

  post: {
    support: originPath,
  },

  put: {
    support: `${originPath}/{supportId}`,
  },

  delete: {
    support: `${originPath}/{supportId}`,
  },
};

export const getRoutes = () => {
  return routes;
};

export const getAll = () => {
  const url = routes.get.supports;
  return axios.get(url);
};

export const getClientVotes = (query = {}) => {
  let params = Object.keys(query).length
    ? `?${new URLSearchParams(query).toString()}`
    : '';

  const url = routes.get.clientVotes + params;
  return axios.get(url);
};

export const createSupport = (supportData, text) => {
  const url = routes.post.support;
  return axios.post(url, supportData);
};

export const editSupport = (supportId, supportData) => {
  const url = routes.put.support.replace('{supportId}', supportId);
  return axios.put(url, supportData);
};

export const deleteSupport = supportId => {
  const url = routes.delete.support.replace('{supportId}', supportId);
  let data = { supportId };

  return axios.delete(url, { data });
};

export const getSupportsData = ({
  date = getISODate(new Date()),
  dateRange = DATE_RANGE.DAY,
}) => {
  const params = `?${new URLSearchParams({
    date,
    dateRange,
  }).toString()}`;

  const url = routes.get.supportsData + params;
  return axios.get(url);
};
